import React from 'react'
import dynamic from 'next/dynamic'
import AppDrawer from '@components/Sidebar/AppDrawer'

const DynamicSignInComponent = dynamic(import('../containers/SignIn'), {
  ssr: false,
})

const SignInPage = () => (
  <>
    <AppDrawer>
      <div>
        <React.Suspense fallback={<div />}>
          <DynamicSignInComponent />
        </React.Suspense>
      </div>
    </AppDrawer>
  </>
)

export default SignInPage
